
const state = {
  tab: {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [],
    15: [],
    16: [],
    17: [],
    18: [],
    19: [],
    20: [],
    21: [],
    22: [],
    23: []
  },
  num: null,
  total: 0, // 总tab数
  isTenTabFlag: false
}

const mutations = {
  // 初始化创意项
  addTabNum(state, num) {
    state.num = num
    state.tab[num] = [{ title: '创意', active: 'tab-active' }]
  },
  // 切换版型
  changeType(state, num) {
    state.num = num
  },
  // 新增tab
  addTab(state, type) {
    // 添加tab
    if (type === 0) {
      state.tab[state.num].push({ title: '创意', active: 'tab-active' })
    }
    // 复制tab
    if (type === 1) {
      state.tab[state.num].push({ title: '创意', active: 'tab-active' })
    }
  },
  // 删除tab
  removeTab(state, e) {
    state.tab[state.num].splice(e, 1)
    if (state.tab[state.num].length === 0) {
      return
    }
    if (state.tab[state.num].length === e) {
      state.tab[state.num][e - 1].active = 'tab-active'
      return
    }
    state.tab[state.num][e].active = 'tab-active'
  },
  // 切换tab
  changeTab(state, e) {
    state.tab[state.num][e].active = 'tab-active'
  },
  // 清空active
  resetActive(state) {
    for (let i = 0; i < state.tab[state.num].length; i++) {
      state.tab[state.num][i].active = ''
    }
  },
  // 判断创意是否超过10个
  isTenTab(state) {
    const key = Object.keys(state.tab)
    state.total = 0
    for (let i = 0; i < key.length; i++) {
      state.total = state.total + state.tab[key[i]].length
    }
  },
  tenTabLimit(state) {
    // 限制tab为10个
    if (state.total >= 10) {
      state.isTenTabFlag = true
      this._vm.$message({
        message: '最多创建10个创意',
        type: 'error'
      })
      return
    }
    state.isTenTabFlag = false
  }
}

const actions = {
  // 初始化
  addTabNumFn(context, num) {
    context.commit('isTenTab')
    if (context.state.isTenTabFlag) {
      context.commit('tenTabLimit')
      return
    } else {
      context.commit('addTabNum', num)
    }
  },
  // 添加tab
  addTabFn(context, e) {
    console.log(context.state.tab, 999)
    context.commit('isTenTab')
    if (context.state.total >= 10) {
      context.commit('tenTabLimit')
      return
    }
    context.commit('resetActive')
    context.commit('addTab', e)
  },
  // 切换tab
  changeTabFn(context, e) {
    if (state.tab.length === 0) {
      return
    }
    context.commit('resetActive')
    context.commit('changeTab', e)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
